/**axios封装
  * 请求拦截、相应拦截、错误统一处理
  */
import axios from 'axios';
import { Toast } from 'vant';
// import CryptoJS from 'crypto-js'
import SHA1  from "sha1"


//   export function getAesString (data) {
//     var eKey = "sa#65$f4";
//     var ivs = "gzsyfdgs";
//     var key = CryptoJS.enc.Utf8.parse(eKey);
//     var iv = CryptoJS.enc.Utf8.parse(ivs);
//     var encrypted = CryptoJS.DES.encrypt(data, key, {
//         iv: iv,
//         mode: CryptoJS.mode.CBC,
//         padding: CryptoJS.pad.Pkcs7
//     });
//     return encrypted.toString();
// };


// console.log(encryptByDES(str,key))

//  console.info("环境:",process.env.NODE_ENV)
// 环境的切换
axios.defaults.baseURL = process.env.VUE_APP_ROOT // 请求地址         
// 请求超时时间
axios.defaults.timeout = 100000;

// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
        // 即使本地存在token，也有可能token是过期的，所以在响应拦截器中要对返回状态进行判断
        //  token && (config.headers.Authorization = token);
        
        config.headers.access_token = localStorage.getItem("access_token");
        config.headers.uniqueId = localStorage.getItem("uniqueId") ;
        return config;
    },
    error => {
        return Promise.error(error);
    })

// 响应拦截器
axios.interceptors.response.use(
    response => {
        if (response&&response.status === 200) {
            return Promise.resolve(response);
        } else {
            return Promise.reject(response);
        }
    },
    // 服务器状态码不是200的情况
    error => {
        console.log(error)

        if (error.response.status) {
            switch (error.response.status) {
                case 401:
                    setTimeout(() => {
                        Toast("身份验证过期，请重新进入问诊")
                    }, 1000);
                    break;
                case 404:
                    Toast({
                        message: '网络请求不存在',
                        duration: 1500,
                        forbidClick: true
                    });
                    break;
                // 其他错误，直接抛出错误提示
                default:
                    Toast({
                        message: error.response.data.message,
                        duration: 1500,
                        forbidClick: true
                    });
            }
            return Promise.reject(error.response);
        }
    }
);
/**
  * get方法，对应get请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function get(url, params) {
    return new Promise((resolve, reject) => {
        axios.get(url, {
            params: params
        })
            .then(res => {
                resolve(res.data);
            })
            .catch(err => {
                reject(err.data)
            })
    });
}


export function guid2() {
    function S4() {
        return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
    }
    return (S4() + S4() + "-" + S4() + "-" + S4() + "-" + S4() + "-" + S4() + S4() + S4());
}

/**
  * post方法，对应post请求
  * @param {String} url [请求的url地址]
  * @param {Object} params [请求时携带的参数]
  */
export function axiosGetOrPost(method,urls, data, tipText, noTip) {
    for(let key  in data){
        console.log(key)
        if(data[key]==null||data[key]==undefined){
            data[key] = ""
        }
        if(typeof(data[key])=="object"){
            data[key] = JSON.stringify(data[key])
        }else{
            // data[key] = String(data[key]).trim()
        }
  }


    let params = cloneObj(data)
    
    params.nonce = guid2()
    params.timestamp = parseInt(new Date()/1000)


    var sorted =Object.keys(params).sort().map(item=>{
        if(typeof(params[`${item}`])=="object"){
            return item+"="+JSON.stringify(params[`${item}`])
        }else{
            return item+"="+params[`${item}`]
        }
        
    }).join("&")
    console.log(sorted)
    var sign = SHA1(sorted)
    console.log(sign)
    var url

    if(method=="post"){
         url = `${process.env.VUE_APP_HOSPITAL}${urls}?`+"sign="+sign.toUpperCase()+`&nonce=${params.nonce}&timestamp=${params.timestamp}`
   }else{
         url = `${process.env.VUE_APP_HOSPITAL}${urls}?`+sorted+"&sign="+sign.toUpperCase()
   }
    
    console.log(url)


    if (tipText) {
        Toast.loading({
            message: tipText,
            duration: 0
        })
    } else {
        if(!noTip){
            Toast.loading({
                message: "加载中",
                duration: 0
            })
        }
    }
    console.log(data)
    return new Promise((resolve, reject) => {
        axios({
            method,
            url,
            data:data
        }).then(res => {
                Toast.clear()
                console.log(res.data)
                    resolve(res.data);
                

            })
            .catch(err => {
                Toast.clear()
                reject(err.data)
            })
    });
}
// 写入带有自定义有效期的cookie
//  使用方式
//这是有设定过期时间的使用示例： 
//s20是代表20秒 
//h是指小时，如12小时则是：h12 
//d是天数，30天则：d30 

//用法示例 setCookie("name","hayden","s20");  cookie过期后会自动消失
export function setCookie(name, value, time) {
    var strsec = getsec(time);
    var exp = new Date();
    exp.setTime(exp.getTime() + strsec * 1);
    document.cookie =
        name + "=" + escape(value) + ";expires=" + exp.toGMTString();
}

//写入带有自定义有效期的cookie的辅助函数
export function getsec(str) {
    var str1 = str.substring(1, str.length) * 1;
    var str2 = str.substring(0, 1);
    if (str2 == "s") {
        return str1 * 1000;
    } else if (str2 == "h") {
        return str1 * 60 * 60 * 1000;
    } else if (str2 == "d") {
        return str1 * 24 * 60 * 60 * 1000;
    }
}

//读取cookies
export function getCookie(name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");

    if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
    else return null;
}

//删除cookies
export function delCookie(name) {
    var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(name);
    if (cval != null)
        document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
}

//   对象深度克隆
export function cloneObj(obj) {
    let newObj=Array.isArray(obj)?[]:{}
    if(obj&&typeof obj ==="object"){
        for(let key in obj){
            if(obj.hasOwnProperty(key)){
                newObj[key]=(obj && typeof obj[key]==='object')?cloneObj(obj[key]):obj[key];
            }
        }
    }
    return newObj
    // if (obj === null) return null
    // if (typeof obj !== 'object') return obj;
    // if (obj.constructor === Date) return new Date(obj);
    // var newObj = new obj.constructor();  //保持继承链
    // for (var key in obj) {
    //     if (obj.hasOwnProperty(key)) {   //不遍历其原型链上的属性
    //         var val = obj[key];
    //         newObj[key] = typeof val === 'object' ? arguments.callee(val) : val; // 使用arguments.callee解除与函数名的耦合
    //     }
    // }
    // return newObj;
}

//  get请求方式参数转post请求参数 : "AppKey=123456&Token=&Name=1 =>{appKey:123456,Token:123}
export function getToPost(data) {
    var postData = {
        values: {
        }
    };
    var commonParam = data
    var item = ''
    var key = ''
    var val = ''
    let commonParamArr = commonParam.split('&');
    console.log(commonParamArr);
    console.log({ ...commonParamArr })
    for (var i = 0, len = commonParamArr.length; i < len; i++) {
        item = commonParamArr[i].split('=');
        key = item[0];
        val = item[1];
        // 排除commonParam内uid、token字段
        if (key == 'uid' || key == 'token') continue;
        postData.values[key] = val;
    }
    console.log(postData.values);
}
export function  addWaterMarker(str, nodes) {
    var can = document.createElement("canvas");
    //水印显示的背景容器
    var body = document.querySelector(nodes);

    body.appendChild(can);

    can.width = 200;
    can.height = 200;
    can.style.display = "none";

    var cans = can.getContext("2d");
    cans.rotate((-20 * Math.PI) /90);
    cans.font = "12px Microsoft JhengHei";
    cans.fillStyle = "rgba(17, 17, 17, 0.50)";
    cans.fillStyle = "	#EBEBEB";
    cans.textAlign = "center";
    cans.textBaseline = "Middle";
    cans.fillText(str, can.width / 3, can.height / 2);

    body.style.backgroundImage = "url(" + can.toDataURL("image/png") + ")";
  }

//   base64转blob
  export function dataURLtoBlob(dataurl) { 
    var arr = dataurl.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
//将blob转换为file
export function blobToFile(theBlob, fileName){
   theBlob.lastModifiedDate = new Date();
   theBlob.name = fileName;
   return theBlob;
}
// 获取年月日时分秒
export function CurentTime(dates) {
    var now
    if(dates){
        now = new Date(dates);
    }else{
        now = new Date();
    }
    var year = now.getFullYear();       
    var month = now.getMonth() + 1;    
    var day = now.getDate();            
    var today = now.getDay();

    var hh = now.getHours();            
    var mm = now.getMinutes();    
    var ss = now.getSeconds();      
    var clock = year + "/";
    if(month < 10) clock += "0";
    clock += month + "/";
    
    if(day < 10) clock += "0";
    clock += day + " ";
    
    // if(hh < 10) clock += "0";
    // clock += hh + ":";
    // if (mm < 10) clock += '0'; 
    // clock += mm; 
    return clock

}
export function computedAges(str)   
{   
      var r  = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/);     
      if(r==null)return   false;     
      var d= new Date(r[1],r[3]-1,r[4]);     
      if(d.getFullYear()==r[1]&&(d.getMonth()+1)==r[3]&&d.getDate()==r[4])   
      {   
        var   Y   =   new   Date().getFullYear();   
        return (Y-r[1])
      }   
      return("输入的日期格式错误！");   
}   
 
export function  getBrowser(){
    const UA = navigator.userAgent || '';
    const isAndroid = !!UA.match(/Android/i);
    const isQQ = /(iPad|iPhone|iPod).*? (IPad)?QQ\/([\d\.]+)/.test(UA) || /\bV1_AND_SQI?_([\d\.]+)(.*? QQ\/([\d\.]+))?/.test(UA);
    const isIOS = !!UA.match(/iPhone|iPad|iPod/i);
    const isSafari = /iPhone|iPad|iPod\/([\w.]+).*(safari).*/i.test(UA);
    const isWx = !!UA.match(/micromessenger/i);
    const isWb = !!UA.match(/weibo/i);
    const isAndroidChrome = (UA.match(/Chrome\/([\d.]+)/) || UA.match(/CriOS\/([\d.]+)/)) && isAndroid && !isQQ;
    const isQZ = UA.indexOf('Qzone/') !== -1;
    const isPC = !isAndroid&&!isIOS&&!isSafari&&!isQQ&&!isQZ&&!isWb&&!isWx&&!isAndroidChrome;
    return {
        isAndroid,
        isIOS,
        isSafari,
        isQQ,
        isWb,
        isWx,
        isQZ,
        isAndroidChrome,
        isPC
    };
}

export function debounce(fn,delay) {
    let timer = null //借助闭包
    return function () {
        if(timer){
            clearTimeout(timer)
        }
        timer = setTimeout(fn,delay)
    }
}

//获取url中的参数
export function getUrlKey(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}


